import { render, staticRenderFns } from "./activateRetentionPay.vue?vue&type=template&id=f776000c&"
import script from "./activateRetentionPay.vue?vue&type=script&lang=js&"
export * from "./activateRetentionPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f776000c')) {
      api.createRecord('f776000c', component.options)
    } else {
      api.reload('f776000c', component.options)
    }
    module.hot.accept("./activateRetentionPay.vue?vue&type=template&id=f776000c&", function () {
      api.rerender('f776000c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/activateRetentionPay.vue"
export default component.exports